import { zodResolver } from "@hookform/resolvers/zod";
import { ReactNode, useEffect } from "react";
import {
  DeepPartial,
  FieldValues,
  FormProvider,
  SubmitHandler,
  UseFormReturn,
  useForm,
} from "react-hook-form";
import { ZodType, output } from "zod";

type Props<ValidationSchema extends ZodType<any, any, any>> = {
  schema?: ValidationSchema;
  defaultValues?: DeepPartial<Record<string, unknown>>;
  onSubmit: SubmitHandler<output<ValidationSchema>>;
  children: ReactNode;
  setMethods?: (method: UseFormReturn<FieldValues, any, undefined>) => void;
  mode?: "onSubmit" | "onBlur" | "onChange" | "onTouched" | "all";
};

export default function FormTemplate<ValidationSchema extends ZodType<any, any, any>>({
  schema,
  defaultValues,
  onSubmit,
  children,
  setMethods,
  mode,
}: Props<ValidationSchema>) {
  const methods = useForm({
    mode: mode ?? "all",
    defaultValues,
    ...(schema ? { resolver: zodResolver(schema) } : {}),
  });

  useEffect(() => {
    if (setMethods) setMethods(methods);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <FormProvider {...methods}>
      <form noValidate onSubmit={methods.handleSubmit(onSubmit)}>
        {children}
      </form>
    </FormProvider>
  );
}
